import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../styles';
import { useSportConfig } from '../../../../hooks/useSportConfig';

const NotEnteredIntoPrizeDraw = ({ eventName }) => {
    const { config } = useSportConfig();
    const { selectionNoun } = config.labels;
    const { eventNoun } = config.labels;

    return (
        <>
            <Styled.Heading>You&#39;re not in the Prize Draw!</Styled.Heading>
            <Styled.Text>
                Your {selectionNoun} didn&#39;t win the {eventName} {eventNoun}.
                You have not been entered into the Prize Draw.
            </Styled.Text>
        </>
    );
};

NotEnteredIntoPrizeDraw.propTypes = {
    eventName: PropTypes.string.isRequired
};

export default NotEnteredIntoPrizeDraw;
